import React from 'react';
import { Button, Modal } from 'antd';

const OverviewModal = ({
  primaryLabel, primaryMethod, secondaryLabel, secondaryMethod, isModalOpen, modalTitle,
}) => {
  const footerButtons = [
    <Button key="discard" onClick={secondaryMethod}>{secondaryLabel}</Button>,
    <Button key="save" type='primary' onClick={primaryMethod}>{primaryLabel}</Button>,
  ];

  return (

    <Modal
      width="500px"
      title="Delete Custom KPI"
      open={isModalOpen}
      onCancel={secondaryMethod}
      footer={footerButtons}
    >
      {modalTitle}
    </Modal>
  );
};

export default OverviewModal;
